import { graphqlRequest } from "../graphqlClient";
import type {
	BaseForecastViewConnection,
	BaseForecastViewFilterInput,
} from "../models/baseForecastView";

export interface BaseForecastViewSortInput {
	field: string;
	order: "Ascending" | "Descending";
}

interface BaseForecastViewListResponse {
	forecast: {
		baseForecastViewList: BaseForecastViewConnection;
	};
}

/**
 * Fetch the ground-truth base forecast (latest completed daily run) via GraphQL.
 * Defaults to ascending date order so the timeline reads chronologically.
 */
export async function getBaseForecastGraphql(
	filter?: BaseForecastViewFilterInput,
	first?: number,
	after?: string,
	sort: BaseForecastViewSortInput[] = [{ field: "Date", order: "Ascending" }],
): Promise<BaseForecastViewConnection> {
	const query = `
    query BaseForecastViewList($filter: BaseForecastViewFilterInput, $first: Int, $after: String, $sort: [BaseForecastViewSortSortByInput!]) {
      forecast {
        baseForecastViewList(filter: $filter, first: $first, after: $after, sort: $sort) {
          edges {
            cursor
            node {
              id
              periodKey
              forecastRunResultId
              date
              openingBalance
              balance
              incoming
              outgoing
              confidenceScore
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }
      }
    }
  `;
	const data = await graphqlRequest<BaseForecastViewListResponse>(query, {
		filter,
		first,
		after,
		sort,
	});
	return data.forecast.baseForecastViewList;
}
